'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { availableColors } from './helpers/mazeUtils';
import { cn } from '@/shared/utils/cn';
import { Button } from '@/shared/components/ui/button';

interface MazeColorSelectorProps {
  selectedColor: string;
  onColorChange: (color: string) => void;
  className?: string;
}

/**
 * Универсальный селектор цветов для лабиринта
 */
export function MazeColorSelector({
  selectedColor,
  onColorChange,
  className
}: MazeColorSelectorProps) {
  const t = useTranslations();

  const colorEntries = Object.entries(availableColors);

  return (
    <div data-testid="maze-color-selector" className={cn('space-y-3', className)}>
      <h3 className="text-sm font-medium text-foreground text-center">
        {t('games.maze.lineColor')}
      </h3>
      
      <div className="flex flex-wrap gap-2 justify-center">
        {colorEntries.map(([colorName, colorValue]) => (
          <Button
            key={colorName}
            data-testid={`maze-color-${colorName}-button`}
            type="button"
            onClick={() => onColorChange(colorValue)}
            variant="ghost"
            size="icon"
            className={cn(
              'w-8 h-8 rounded-full border-2 transition-all duration-200',
              'hover:scale-110',
              selectedColor === colorValue
                ? 'border-foreground shadow-lg scale-110'
                : 'border-border hover:border-muted-foreground'
            )}
            style={{ backgroundColor: colorValue }}
            title={t(`games.maze.colors.${colorName}`)}
            aria-label={t(`games.maze.colors.${colorName}`)}
          />
        ))}
      </div>
      
      {/* Описание выбранного цвета */}
      <p className="text-xs text-muted-foreground text-center">
        {t('games.maze.selectedColor')}: {
          colorEntries.find(([, value]) => value === selectedColor)?.[0] 
            ? t(`games.maze.colors.${colorEntries.find(([, value]) => value === selectedColor)?.[0]}`)
            : t('games.maze.colors.blue')
        }
      </p>
    </div>
  );
}
